import supabaseClient from '@/api/supabaseClient.ts';
import { SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { queryClient } from '@/main.tsx';
import { DeleteRestaurantsRequest } from '@/types/request/DeleteRestaurantsRequest';

const useRestaurantDelete = () => {
  const client = supabaseClient;

  const mutationFn = async (request: DeleteRestaurantsRequest) => {
    return deleteRestaurant(client, request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['restaurants'] });
    },
  });
};

export default useRestaurantDelete;

async function deleteRestaurant(client: SupabaseClient, request: DeleteRestaurantsRequest): Promise<void> {
  const { error } = await client.from('restaurants').delete().in('id', request.ids);

  if (error) throw new Error(error.message);

  return;
}
